import { useGate, useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import {
  Registration,
  registrationStepModel,
  useTitle,
} from '~/features/Registration'
import { driverModel } from '~/entities/Driver'
import { PageContainer } from '~/shared/ui/PageContainer'
import { SuccessStep } from './SuccessStep'

export const LeadRegistrationPage = () => {
  useGate(registrationStepModel.Gate)

  const defaultValues = useStoreMap(driverModel.$driver, (driver) => ({
    phone: driver?.getPhone(),
    lastName: driver?.getLastName(),
    firstName: driver?.getFirstName(),
  }))

  const {
    isPassportStep,
    isDriverLicenseStep,
    isConfirmCodeStep,
    isErrorStep,
  } = useStore(registrationStepModel.$currentStepFlags)

  const title = useTitle()

  const pageContainerProps = useMemo(() => {
    return {
      ...(isPassportStep || isDriverLicenseStep
        ? { onBack: registrationStepModel.goToBackStep }
        : {}),
      ...(isConfirmCodeStep
        ? { contentFillColor: null, onBack: registrationStepModel.goToBackStep }
        : {}),
      ...(isErrorStep ? { onBack: registrationStepModel.goToConfirmStep } : {}),
    }
  }, [isConfirmCodeStep, isDriverLicenseStep, isErrorStep, isPassportStep])

  return (
    <PageContainer
      title='Регистрация'
      backTitle={title}
      canBack
      {...pageContainerProps}
    >
      <Registration
        SuccessStep={SuccessStep}
        basicInformationDefaultValues={defaultValues}
        disabledChangePhone
      />
    </PageContainer>
  )
}
